module.exports = __webpack_public_path__ + "assets/images/yellow-circle_11c2a7369c5e9ec99c831cbc36eff9ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forms/yellow-circle.png
// module id = 145
// module chunks = 0